import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

export const fetchOrganization = createAsyncThunk(
  "organization/fetchOrganization",
  async (_, { rejectWithValue }) => {
    try {
     const res = await fetch("/api/v1/admin/organization", {
        credentials: "include",
      });
      if (!res.ok) throw new Error("Failed to fetch organization");
      return await res.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// Update org data
export const updateOrganization = createAsyncThunk(
  "organization/updateOrganization",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await fetch("/api/v1/admin/organization", {
        method: "PUT",
         headers: {
             "X-CSRF-Token": csrfToken, 
         },
        body: formData, 
        credentials: "include",
      });

      const result = await res.json();
      if (!res.ok) throw new Error(result.errors?.join(", ") || "Failed to update organization");
      return result;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const organizationSlice = createSlice({
  name: "organization",
  initialState: {
    data: null,      // Organization data
    submitting: false,
    error: null,
    loading: false
  },
  reducers: {
    setOrganization: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganization.pending, (state) => {
        state.loading = true;
        state.error = null;
        })
      .addCase(fetchOrganization.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        })
      .addCase(fetchOrganization.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
        })
      .addCase(updateOrganization.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(updateOrganization.fulfilled, (state, action) => {
        state.submitting = false;
        state.data = action.payload;
      })
      .addCase(updateOrganization.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      });
  },
});

export const { setOrganization } = organizationSlice.actions;
export default organizationSlice.reducer;